import { useParams } from "react-router-dom";
import {DiscountDetails, PointsExchangeDetails, TravelTransactionDetails} from "./components";
import HotelTransactionDetails from "./components/HotelTransactionDetails/HotelTransactionDetails";
import { MenuRoutesType } from "src/constants/modules";
import { useSelector } from "react-redux";
import { RootState } from "src/store";
import GiftcardsDetails from "./components/GiftcardDetails/GiftcardDetails";
import OrderDetailsHeader from "./components/OrderDetailsHeader/OrderDetailsHeader";

const MODULE_DETAILS: Record<MenuRoutesType, JSX.Element> = {
  travel: <TravelTransactionDetails />,
  hotel: <HotelTransactionDetails />,
  points:<PointsExchangeDetails/>,
  giftcards:<GiftcardsDetails/>,
  discounts:<DiscountDetails/>,
};

export default function OrderDetails() {
  const { module, id } = useParams();
  const clientId = useSelector((state:RootState)=>state.client.selectedClientId);
  const Module = clientId && module && MODULE_DETAILS[module];
  return (
    <div className="flex w-full flex-1 flex-col items-start gap-5 p-6 md:p-10">
      <OrderDetailsHeader label={id} />
      {Module}
    </div>
  );
}
